module.exports = "/_next/static/images/c00bb3b00d46513921d4ced4b9d86d56-double-card@1x.png";